export { paginationComponentOptions } from "./pagination-component-options";
